import { render, staticRenderFns } from "./MerchantTransaction.vue?vue&type=template&id=22d76d5c&scoped=true"
import script from "./MerchantTransaction.vue?vue&type=script&lang=js"
export * from "./MerchantTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d76d5c",
  null
  
)

export default component.exports